export default import.meta.ROLLDOWN_FILE_URL_OFkq5yBAjMqRj2eJc6Typw